import {Grid} from "@material-ui/core";
import {Skeleton} from "@material-ui/lab";
import PropTypes from "prop-types";

const LoadingBoxSkeletons = (props) => {
    const buildSkeletons = () => {
        return [...Array(props.count)].map((skeleton, indx) => {
            return (
                <Grid item
                      key={`loading-skeleton-box-${indx}`}
                      xs={props.direction === 'vertical' ? 12 : 12}
                      sm={props.direction === 'vertical' ? 12 : 12}
                      md={props.direction === 'vertical' ? 12 : 6}
                      lg={props.direction === 'vertical' ? 12 : 4}>
                    <Skeleton variant="rect" width="100%" height={props.height}/>
                </Grid>
            )
        })
    }

    return (
        <Grid container
              direction={props.direction === 'vertical' ? 'column' : 'row'}
              spacing={4}>
            {buildSkeletons()}
        </Grid>
    )
}

LoadingBoxSkeletons.defaultProps = {
    direction: 'horizontal'
}

LoadingBoxSkeletons.propTypes = {
    height: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    direction: PropTypes.oneOf(['horizontal', 'vertical']),
}

export default LoadingBoxSkeletons;